import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../../../components/Header/Header';
import DeviceMapPanel from '../../../components/Maps/DeviceMapPanel';
import './DevicesMap.scss';

class DevicesMapPage extends Component {
  state = {
    colorMode: 'status',
  };

  handleColorModeChange = colorMode => {
    if (!colorMode) {
      return;
    }

    this.setState({ colorMode });
  };

  render() {
    const { colorMode } = this.state;

    return (
      <div className="page-structure page-structure--map">
        <Helmet title="Map" />
        <Header />
        <div className="mt-8 flex flex-col flex-1 min-h-0">
          <div className="page-panels page-panels--map ">
            <div className="page-content page-devices-map  ">
              <DeviceMapPanel
                colorMode={colorMode}
                onColorModeChange={this.handleColorModeChange}
                dataUrl="/cms/data/v1/devices/map"
                pollIntervalMs={15000}
                showSummary
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DevicesMapPage);
